var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUploads2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.293 1.707a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1-1.415 1.414L9 4.828v5.673a1 1 0 1 1-2 0V4.83L5.17 6.657a1 1 0 1 1-1.414-1.414l3.524-3.524.012-.012z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 9v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9h2v3a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9h2z",
  fill: "currentColor"
})));
export { SvgUploads2 as ReactComponent };